import { render, staticRenderFns } from "./DepartPL.vue?vue&type=template&id=f02bfd68&scoped=true&"
import script from "./DepartPL.vue?vue&type=script&lang=js&"
export * from "./DepartPL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02bfd68",
  null
  
)

export default component.exports